export default __webpack_public_path__ + "static/media/Icon=Task List.de00c753.svg";